// libraries.
import { useFormContext } from 'react-hook-form';

// hooks.
import { useAutocompleteConfidence } from '@domains/documents-review/hooks/useAutocompleteConfidence';

// components.
import { InputField } from '@shared/InputField/InputField';
import { NumericField } from '@shared/NumericField/NumericField';
import { DropdownField } from '@shared/DropdownField/DropdownField';
import { PriceInputField } from '@shared/PriceInputField/PriceInputField';
import { MultiSelectDropdownField } from '@shared/MultiSelectDropdownField/MultiSelectDropdownField';

// utils.
import { calculateYears } from '@domains/hermes/utils/calculateYears';
import { DROPDOWN_OPTIONS } from '../../constants';

export const FieldsCO = () => {
  const { watch } = useFormContext();
  const { getConfidenceProps } = useAutocompleteConfidence();

  const hasAdmin = watch('hasAdmin');
  const hasGarage = watch('hasGarage');
  const hasTerrace = watch('hasTerrace');
  const constructionDate = watch('constructionDate');
  const yearsOld = constructionDate ? calculateYears(constructionDate) : '';

  return (
    <>
      <div className="d-flex gap-2">
        <DropdownField
          label="Recibo admin.*"
          name="hasAdmin"
          options={DROPDOWN_OPTIONS.YES_NO}
          required
          {...getConfidenceProps('hasAdmin')}
        />
        {hasAdmin === 1 && (
          <PriceInputField
            label="Valor admin."
            name="adminPrice"
            required
            {...getConfidenceProps('adminPrice')}
          />
        )}
      </div>
      <InputField
        label="Fecha construcción del inmueble*"
        type="date"
        name="constructionDate"
        required
        {...getConfidenceProps('constructionDate')}
      />
      {constructionDate && (
        <InputField
          label="Antigüedad"
          name="yearsOld"
          placeholder={yearsOld?.toString()}
          disabled
          subLabel="años"
        />
      )}
      <div className="d-flex gap-2">
        <DropdownField
          label="Tipo de área"
          name="areaType"
          options={DROPDOWN_OPTIONS.AREA_TYPE}
          {...getConfidenceProps('areaType')}
        />
        <InputField
          label="Área*"
          maxLength={3}
          name="area"
          pattern={/^\d{1,3}$/}
          placeholder="Área"
          subLabel="m²"
          required
          {...getConfidenceProps('area')}
        />
      </div>
      <div className="d-flex gap-2">
        <NumericField
          label="Baños*"
          name="baths"
          placeholder="Baños"
          required
          {...getConfidenceProps('baths')}
        />
        <NumericField
          label="Piso*"
          name="floor"
          placeholder="Piso"
          required
          {...getConfidenceProps('floor')}
        />
      </div>
      <div className="d-flex gap-2">
        <DropdownField
          label="Garaje*"
          name="hasGarage"
          options={DROPDOWN_OPTIONS.GARAGE}
          required
          {...getConfidenceProps('hasGarage')}
        />
        {hasGarage === 'Si' && (
          <NumericField
            label="Cantidad de garajes*"
            name="garage"
            placeholder="Garage"
            required
            {...getConfidenceProps('garage')}
          />
        )}
      </div>
      <div className="d-flex gap-2">
        <DropdownField
          label="Balcón/Terraza (opc)"
          name="hasTerrace"
          options={DROPDOWN_OPTIONS.YES_NO}
          {...getConfidenceProps('hasTerrace')}
        />
        {hasTerrace === 1 && (
          <InputField
            label="Área libre (opc)"
            maxLength={3}
            name="freeArea"
            pattern={/^\d{1,3}$/}
            placeholder="Área"
            subLabel="m²"
            {...getConfidenceProps('freeArea')}
          />
        )}
      </div>
      <MultiSelectDropdownField
        label="Gravámenes*"
        name="liens"
        options={DROPDOWN_OPTIONS.LIEN_LIST}
        required
        {...getConfidenceProps('liens')}
      />
      <DropdownField
        label="Categoría de Gravamen*"
        name="liensCategory"
        options={DROPDOWN_OPTIONS.LIEN_CATEGORY}
        required
        {...getConfidenceProps('liensCategory')}
      />
      <DropdownField
        label="Banco hipoteca (opcional)"
        name="lenderBank"
        options={DROPDOWN_OPTIONS.BANK_LIST}
        {...getConfidenceProps('lenderBank')}
      />
    </>
  );
};
